module.exports = __webpack_public_path__ + "img/Payment_Live.2966d341.png";